export enum Role {
  SUPER,
  ADMIN,
  MANAGER,
  SUPERVISOR,
  SALESMAN
}